import "../../style.css";
import moment from "moment";
import TabView from "./TabView";
import TableView from "./TableView";
import TableAction from "./TableAction";
import CategoryView from "./CategoryView";
import { Toaster } from 'react-hot-toast';
import { useEffect, useState } from "react";

function Calendar() {
	// States
	const [wpUserLoggedIn, setHasBodyClass] = useState(false);
	const [tab, setTab] = useState();
	const [activeTab, setActiveTab] = useState(1);
	const [categories, setCategories] = useState([]);
	const [comments, setComments] = useState([]);
	const [updateValue, setUpdatedValue] = useState([]);
	const [loading, setLoading] = useState(0);

	const handleTabSelect = (tabId) => {
		// Update active tab when a new tab is selected
		setActiveTab(tabId);
	};

	const currentYear = moment().year();
	const [year, setYear] = useState(currentYear);

	useEffect(() => {
		const checkBodyClass = () => {
			if (document.body.classList.contains("logged-in")) {
				setHasBodyClass(true);
			} else {
				setHasBodyClass(false);
			}
		};

		// Determine the current month and set active tab
		const currentMonth = moment().month();
		if (currentMonth >= 0 && currentMonth <= 5) {
			// January to June
			setActiveTab(1);
		} else {
			// July to December
			setActiveTab(2);
		}

		checkBodyClass();
	}, []);

	useEffect(() => {
		if (updateValue.id !== undefined) {
			setComments((comments) => {
				const newData = [...comments];

				newData.forEach((value) => {
					if (value.id === updateValue.id) {
						const existingWeekData = value.week_data.find(
							(weekDays) =>
								weekDays.timeslot_id ===
								updateValue.week_data[0].timeslot_id
						);
						if (existingWeekData) {
							existingWeekData.category.id =
								updateValue.week_data[0].category.id;
							existingWeekData.category.name =
								updateValue.week_data[0].category.name;
							existingWeekData.category.details =
								updateValue.week_data[0].category.details;
							existingWeekData.category.color =
								updateValue.week_data[0].category.color;
						} else {
							// Create new week_data and push it
							value.week_data.push(updateValue.week_data[0]);
						}
					}
				});

				return newData;
			});
		}
	}, [updateValue]);

	return (
		<div className={wpUserLoggedIn ? "admin-view" : "public-view"}>
			<Toaster
				position="top-right"
				reverseOrder={true}
			/>

			<div className={"py-3"}>
				<CategoryView
					categories={categories}
					setCategories={setCategories}
					setTab={setTab}
					setLoading={setLoading}
				/>
			</div>

			<div className={"py-3"}>
				{tab !== undefined && (
					<TabView tab={tab} activeTab={activeTab} handleTabSelect={handleTabSelect} />
				)}
			</div>

			<div
				className={
					"d-flex justify-content-center justify-content-md-end py-2"
				}
			>
				<TableAction
					wpUserLoggedIn={wpUserLoggedIn}
					activeTab={activeTab}
					year={year}
					setYear={setYear}
					currentYear={currentYear}
					comments={comments}
					setComments={setComments}
				/>
			</div>

			<TableView
				loading={loading}
				wpUserLoggedIn={wpUserLoggedIn}
				activeTab={activeTab}
				year={year}
				categories={categories}
				comments={comments}
				setComments={setComments}
				setUpdatedValue={setUpdatedValue}
			/>
		</div>
	);
}

export default Calendar;
